import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";
import DropZone from "../components/DropZone";
import ReorderList from "../components/ReorderList";

function resolveSrc(u) { if (!u) return ""; if (u.startsWith("http")) return u; if (u.startsWith("/api/media/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`; return u; }

export default function CertificationsEditor() {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/kv/certifications").then(({ data }) => Array.isArray(data) && setItems(data));
  }, []);

  const upd = (i, k, v) => setItems((arr) => { const a = [...arr]; a[i] = { ...a[i], [k]: v }; return a; });
  const add = () => setItems((arr) => [...arr, { name: "", logo: "", url: "", description: "", category: "certificacao" }]);
  const remove = (i) => setItems((arr) => arr.filter((_, j) => j !== i));

  const save = async () => {
    setSaving(true);
    try { await api.put("/content/kv/certifications", { value: items }); toast.success("Salvo."); }
    catch { toast.error("Erro ao salvar."); }
    finally { setSaving(false); }
  };

  const CAT_OPTS = [
    { v: "reconhecimento", label: "Reconhecimento" },
    { v: "parceria", label: "Parceria Oficial" },
    { v: "certificacao", label: "Certificação" },
  ];

  return (
    <div>
      <div className="flex justify-between items-end mb-6">
        <div>
          <h1 className="font-display text-4xl">Reconhecimentos · Parcerias · Certificações</h1>
          <p className="text-sm text-neutral-500 mt-1">Cada selo tem uma categoria — a página /sobre exibe 3 seções separadas com base nesta escolha. Adicione quantos quiser em cada categoria.</p>
        </div>
        <button onClick={save} disabled={saving} data-testid="certifications-save" className="bg-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-accent-orange disabled:opacity-50"><Save className="w-3 h-3 inline mr-1" /> {saving ? "Salvando…" : "Salvar"}</button>
      </div>

      <section className="border border-black/10 p-5 rounded">
        <div className="flex justify-between items-center mb-4">
          <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700">Selos cadastrados ({items.length})</div>
          <button onClick={add} className="text-xs bg-accent-yellow px-3 py-1 rounded-full font-semibold" data-testid="certification-add"><Plus className="w-3 h-3 inline" /> Adicionar</button>
        </div>
        <ReorderList
          items={items}
          onChange={setItems}
          getKey={(_c, i) => `cert-${i}`}
          renderItem={(c, i) => (
            <div className="border border-black/10 p-4 rounded space-y-2" data-testid={`certification-${i}`}>
              <div className="text-xs font-semibold text-neutral-500">Selo {i + 1}</div>
              <select value={c.category || "certificacao"} onChange={(e) => upd(i, "category", e.target.value)} className="w-full border border-black/15 px-2 py-1.5 rounded text-sm bg-white" data-testid={`certification-cat-${i}`}>
                {CAT_OPTS.map((o) => <option key={o.v} value={o.v}>{o.label}</option>)}
              </select>
              {c.logo && <div className="flex items-center justify-center min-h-[80px] bg-neutral-50 p-3 rounded"><img src={resolveSrc(c.logo)} alt="" className="max-h-16 max-w-full object-contain" /></div>}
              <DropZone multiple={false} onUploaded={(f) => upd(i, "logo", f.url)} />
              <input value={c.logo || ""} onChange={(e) => upd(i, "logo", e.target.value)} placeholder="ou URL do logo" className="w-full text-xs border border-black/15 px-2 py-1.5 rounded" />
              <input value={c.name || ""} onChange={(e) => upd(i, "name", e.target.value)} placeholder="Nome (ex.: Google Partner)" className="w-full border border-black/15 px-2 py-1.5 rounded text-sm font-semibold" />
              <input value={c.description || ""} onChange={(e) => upd(i, "description", e.target.value)} placeholder="Descrição curta" className="w-full border border-black/15 px-2 py-1.5 rounded text-sm" />
              <input value={c.url || ""} onChange={(e) => upd(i, "url", e.target.value)} placeholder="URL (opcional, abre em nova aba)" className="w-full border border-black/15 px-2 py-1.5 rounded text-sm" />
            </div>
          )}
        />
      </section>
    </div>
  );
}
